export default __webpack_public_path__ + "static/media/cif-dj.4751653e.svg";